import { createComponent as _$createComponent } from "solid-js/web";
import { browserSettingsStore } from "../audio/settings.ts";
import { createGamepadControls } from "../flight/gamepad.ts";
import { storePreferenceSinks } from "../mission/preferences.ts";
import { createPreferencesSurface } from "../shell/preferences-surface.ts";
import { onCleanup } from "solid-js";
import { ScreenShell } from "../shell/ScreenShell.tsx";
import { SHELL_ROUTES } from "../shell/model/red-baron-shell.ts";

/**
 * `/settings` — PREFERENCES, in the shell (AD-009), reached from the Main
 * Menu's `OTHER OPTIONS -> PREFERENCES`, which is where the original keeps its
 * own preferences entry. The same panel `O` opens over a flight
 * (`flight/PreferencesOverlay.tsx`); the only difference is that here ACCEPT
 * goes back to the Main Menu instead of back to the aeroplane.
 *
 * One line of wiring, like every other shell route: the screen is
 * `shell/model/preferences-screen.ts`, the behaviour
 * `shell/preferences-surface.ts`, and the settings themselves are the five
 * stores `mission/preferences.ts` reads — nothing is copied into a new key.
 */
export function Settings() {
  const store = browserSettingsStore();
  // The menus have no aeroplane, so the stick here is a *feed* and nothing
  // else: no command sink and permanently blocked, which is the whole of what
  // "the panel cannot fly anything" means on a route with nothing to fly.
  const gamepad = createGamepadControls({
    store,
    onCommand: () => {},
    blocked: () => true
  });
  onCleanup(() => gamepad.dispose());
  return _$createComponent(ScreenShell, {
    get controller() {
      return createPreferencesSurface({
        store,
        sinks: storePreferenceSinks(store),
        onClose: () => SHELL_ROUTES.title,
        gamepad
      });
    },
    label: "Preferences"
  });
}